import { useRef, useState } from 'react';
import { Button, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { formatAgeString, getGender, getLink, getMaximumKey, getRandomColor, getTop10Records, getUserType, sumOfAll } from '../../utils/common';
import { COUNTRY_JSON, TOOLTIP_STYLES, YOUTUBE_TYPE, getDecimal, getFixedValue, gettwoDigitFixedValue, gradientText, hideScrollbarCss, mainGradient } from '../../utils/constant';
import Brands from './Brands';
import Posts from './Posts';
import profilePlatformIcon from '../../assets/images/icons/profilePlatformIcon.svg'
import engagementIcon from '../../assets/images/icons/dashboardEne.svg'
import imageIcon from '../../assets/images/icons/imageIconBlack.svg'
import usersIcon from '../../assets/images/icons/dashboardUser.svg'
import growthIcon from '../../assets/images/icons/growthIcon.svg'
import tagIcon from '../../assets/images/icons/tagIcon.svg'
import exitIcon from '../../assets/images/icons/logouticon.svg'
import voiceIcon from '../../assets/images/icons/voiceIcon.svg'
import chartIcon from '../../assets/images/icons/chartIcon.svg'
import trendingUpIcon from '../../assets/images/icons/trendingUpIcon.svg'
import dummyProfileOverallScore from '../../assets/images/icons/dummyProfileOverallScore.png'
import dummyProfileInflyxScore from '../../assets/images/icons/dummyProfileInflyxScore.png'
import dummyProfileEngagementScore from '../../assets/images/icons/dummyProfileEngagementBar.png'
import profileReelIcon from '../../assets/images/icons/profileReelIcon.svg'
import profileCommentIcon from '../../assets/images/icons/profileCommentIcon.svg'
import likeIcon from '../../assets/images/icons/likeIcon.svg'
import eyeIcon from '../../assets/images/icons/openEye.svg'
import mapPinIcon from '../../assets/images/icons/mapPinIcon.png'
import navigationIcon from '../../assets/images/icons/navigationIcon.svg'
import globeIcon from '../../assets/images/icons/globeIcon.svg'
import cakeIcon from '../../assets/images/icons/cakeIcon.svg'
import certificateIcon from '../../assets/images/icons/certificateBadgeIcon.svg'
import { Bar } from 'react-chartjs-2';
import maleIcon from '../../assets/images/icons/maleIcon.svg'
import femaleIcon from '../../assets/images/icons/femaleIcon.svg'
import infoIcon from '../../assets/images/icons/infoIcon.svg'
import { useSelector } from 'react-redux';
function LinearProgressWithLabel(props) {
  return (
    <Box className="barListItem">
      <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
        <Typography fontSize={12} fontWeight={400} color={"black"}>{props.country}</Typography>
        <Typography fontSize={12} fontWeight={400} color={"black"}> {`  ${getDecimal(props.value)
          }%`}</Typography>
      </Stack>
      <Stack className='d-flex align-items-center' style={{ flexDirection: 'row', height: '12px' }}>
        <LinearProgress value={getDecimal(props.value)}
          sx={{
            width: '100%',
            height: 8, marginTop: '5px',
            borderRadius: 8,
            "& .MuiLinearProgress-bar": {
              borderRadius: 8,
              backgroundColor: getRandomColor(),
            },
            backgroundColor: "#eee"
          }} variant="determinate" {...props} />
        &nbsp;
      </Stack>
    </Box>
  );
}
const CommingSoonUi = ({ breakLine = false }) => {
  return (
    <Stack justifyContent={"center"} alignItems={"center"} sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "8px",
      border: "2px solid transparent",
      borderImage: `${mainGradient} 1 / / rounded`, // gradient border
      backgroundColor: "rgba(250, 250, 250, 0.6)",
      backdropFilter: "blur(8px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Typography sx={{ ...gradientText, textAlign: 'center', fontSize: '48px', fontWeight: 700, }}>Coming {breakLine && <br />} Soon</Typography>
    </Stack>
  )
}
const EngagementInfoCard = ({ image, value, text }) => {
  return (
    <>
      <Stack direction={"column"} padding={"16px 10px"} borderRadius={'10px'} border="1px solid #F0F0F0" justifyContent={"space-between"} alignItems={"center"} height={'136px'} width={"100%"}>
        <img src={image} alt="EngagementInfoCard" style={{ height: '24px', width: '24px' }} />
        <Typography fontSize={20} fontWeight={600} color={"black"}>{value}</Typography>
        <Typography fontSize={14} fontWeight={400} color="#726C6C">{text}</Typography>
      </Stack>
    </>
  )
}
const LocationCard = ({ image, text, value }) => {
  return (
    <>
      <Stack height={"126px"} width={"250px"} direction={"column"} padding={"24px 12px"} border={"1px solid #EEE"} borderRadius={'6px'} justifyContent={"space-between"} alignItems={"flex-start"}>
        <img src={image} alt="icon" style={{ width: '24px', height: '24px' }} />
        <Typography fontSize={12} fontWeight={400} color={"#726C6C"}>{text}</Typography>
        <Typography fontSize={16} fontWeight={500} color={"#000000"}>{value}</Typography>
      </Stack>
    </>
  )
}
const SocialProfileSummary = ({ data }) => {
  const [audienceTab, setAudienceTab] = useState(data?.Audience?.cities?.length > 0 ? "city" : data?.Audience?.state?.length > 0 ? "state" : "country")
  const [showAllHastags, setShowAllHastags] = useState(false);
  const [childElementIdForScroll, setChileElementIdForScroll] = useState("#platforms")
  const links = [{ label: 'Overview', href: '#overview', icon: profilePlatformIcon }, { label: 'Engagement', href: '#engagement', icon: engagementIcon }, { label: 'Content', href: '#content', icon: imageIcon }, { label: 'Audience', href: '#audience', icon: usersIcon }, { label: 'Growth', href: '#growth', icon: growthIcon }, { label: 'Brands', href: '#brands', icon: tagIcon },]
  const contentRef = useRef(null);
  const {isScreenZoomed} = useSelector(state=>state.commonSlice);
  const onSmoothClick = (e, href) => {
    const id = href.replace("#", "")
    console.log(contentRef, 'contentRef', document.getElementById('parent'))
    const parentEle = document.getElementById('parent');
    const childEle = document.getElementById(id);
    setChileElementIdForScroll('#' + id);
    if (parentEle && childEle) {
      parentEle.scrollTop = childEle.offsetTop
      e.preventDefault()
      parentEle.scrollIntoView({
        behavior: "smooth",
      })
    }
  }
  const labelsForAgeGroupGraph = data?.Audience?.age_group?.map(item => Object.keys(item)[0]);
  const valuesForAgeGroupGraph = data?.Audience?.age_group?.map(item => Object.values(item)[0]);
  const totalForAgeGroupGraph = valuesForAgeGroupGraph.reduce((acc, val) => acc + val, 0);
  const percentages = valuesForAgeGroupGraph.map(val => ((val / totalForAgeGroupGraph) * 100).toFixed(2));
  const dataForAgeGroupGraph = {
    labels: labelsForAgeGroupGraph,
    datasets: [
      {
        label: "Audience Age Group (%)",
        data: percentages,
        backgroundColor: "#0077FF",
        borderRadius: 6,
        maxBarThickness: 40
      },
    ],
  };
  function getGenderStats(data = []) {
    let male = 0;
    let female = 0;
    data.forEach(item => {
      male += item.Male || item.m || item.male || item.M || 0;
      female += item.Female || item.f || item.female || item.F || 0;
    });
    const total = male + female;
    const malePercent = total ? ((male / total) * 100).toFixed(2) : 0;
    const femalePercent = total ? ((female / total) * 100).toFixed(2) : 0;
    return [
      { gender: "Male", value: male, percentage: Number(malePercent) },
      { gender: "Female", value: female, percentage: Number(femalePercent) }
    ];
  }
  const GENDER_AUDIANCE_GRAPH_DATA = getGenderStats(data?.Audience?.gender);
  const userType = getUserType();
  return (
    <>
      <Stack direction={"row"} padding={'0px 16px'} position={"relative"} border={'0px solid red'} sx={{height : userType === 'admin' ? (isScreenZoomed ? '50vh' : '60vh') : (isScreenZoomed ? '65vh' : '69vh') }}>
        <Box sx={{ width: '15%', height: '100%', position: 'sticky', top: 0, border: '0px solid blue', paddingTop: '20px' }}>
          {/* navbar */}
          <Stack direction={"column"} gap={2}>
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => onSmoothClick(e, l.href)}
                style={{ display: 'flex', flexDirection: 'row', gap: '10px', textDecoration: 'none', alignItems: 'center' }}
              >
                <img src={l.icon} alt={l.icon} style={{
                  height: '20px', width: '20px', filter:
                    childElementIdForScroll === l.href
                      ? "brightness(0) saturate(100%) invert(38%) sepia(95%) saturate(7485%) hue-rotate(202deg) brightness(103%) contrast(104%)"
                      : "brightness(0)",
                }} />
                <Typography fontSize={16} fontWeight={400} color={childElementIdForScroll === l.href ? "var(--color-blue)" : 'black'}>{l.label}</Typography>
              </a>
            ))}
            <a href="#/" style={{ color: 'black', display: 'flex', flexDirection: 'row', gap: '10px', textDecoration: 'none', alignItems: 'center' }} onClick={(e) => { e.preventDefault(); window.open(getLink(data?.platformType, data?.handleName), "_blank"); }} target='_blank'><img src={exitIcon} alt={exitIcon} style={{ height: '18px', width: '18px' }} /> {data?.platformType === "youtube" ? "Open Youtube" : "Open Instagram"}</a>
          </Stack>
        </Box>
        <Box sx={{
          width: '85%', height: '100%', border: '0px solid red', overflowY: 'scroll', position: 'relative', borderLeft: '1px solid #F0F0F0',
          scrollBehavior: 'smooth', overscrollBehavior: 'contain', padding: '0px 20px 0 40px'
        }} id="parent" ref={contentRef} >
          <Box id='overview' paddingTop={'20px'}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <img src={profilePlatformIcon} style={{ width: '24px', height: '24px' }} alt={profilePlatformIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Overview</Typography>
            </Stack>
            <Stack sx={{ height: '340px', width: '100%', border: '0px solid red', marginTop: '40px', gap: '16px' }} direction={"row"}>
              <Stack
                sx={{
                  width: "75%",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
                direction="row">
                <Box sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <img src={voiceIcon} alt="voiceIcon" style={{ height: '30px', width: '30px' }} />
                    <Typography sx={{ padding: '4px 8px', fontSize: '12px', fontWeight: 600, color: '#CE1111', background: '#FCDFDF', borderRadius: '20px', display: 'none' }}>Low</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C' }}>{data?.platformType === YOUTUBE_TYPE ? "Total Videos" : "Estimated Reach"}</Typography>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}> <img src={trendingUpIcon} alt="trendingUpIcon" style={{ height: '30px', width: '30px', display: 'none' }} /> <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.platformType === YOUTUBE_TYPE ? (data?.content?.post?.length || "N/A") : (parseInt(data?.Audience?.reach) ? getFixedValue(data?.Audience?.reach) : "N/A")}</Typography><Typography fontSize={12} fontWeight={400} color={"#726C6C"}>per 30 days</Typography></Stack>
                </Box>
                <Box sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <img src={engagementIcon} alt="engagementIcon" style={{ height: '30px', width: '30px', }} />
                    <Typography sx={{ padding: '4px 8px', fontSize: '12px', fontWeight: 600, color: '#CE1111', background: '#FCDFDF', borderRadius: '20px', display: 'none' }}>Low</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C', textTransform: 'capitalize' }}>{data?.platformType === YOUTUBE_TYPE ? "AVG. VIEWS" : "ENGAGEMENT RATE"}</Typography>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}> <img src={trendingUpIcon} alt="trendingUpIcon" style={{ height: '30px', width: '30px', display: 'none' }} /> <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.platformType === YOUTUBE_TYPE ? getFixedValue(data?.Engagement?.posts?.avg_views) : gettwoDigitFixedValue(data?.overview?.engagement_rate) + "%" || "N/A"}</Typography><Typography fontSize={12} fontWeight={400} color={"#726C6C"}>per 30 days</Typography></Stack>
                </Box>
                <Box sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <img src={usersIcon} alt="usersIcon" style={{ height: '30px', width: '30px' }} />
                    <Typography sx={{ padding: '4px 8px', fontSize: '12px', fontWeight: 600, color: '#CE1111', background: '#FCDFDF', borderRadius: '20px', display: 'none' }}>Low</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C', textTransform: 'capitalize' }}>{data?.platformType === YOUTUBE_TYPE ? "SUBSCRIBERS" : "Followers"}</Typography>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}><Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{getFixedValue(data?.followers) || "N/A"}</Typography></Stack>
                </Box>
                <Box sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px', display: 'none' }}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <img src={chartIcon} alt="chartIcon" style={{ height: '30px', width: '30px' }} />
                    <Typography sx={{ padding: '4px 8px', fontSize: '12px', fontWeight: 600, color: '#CE1111', background: '#FCDFDF', borderRadius: '20px', display: 'none' }}>Low</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C' }}>Quality Audience</Typography>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}><Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.followers ? "75%" : "N/A"}</Typography><Typography fontSize={12} fontWeight={500} color={"#726C6C"}>{getFixedValue(data?.followers) || "N/A"}</Typography></Stack>
                </Box>
              </Stack>
              <Box sx={{ width: '25%', position: 'relative' }}>
                <img src={dummyProfileOverallScore} alt="dummyProfileOverallScore" style={{ width: '100%', height: '100%' }} />
                <CommingSoonUi breakLine={true} />
              </Box>
            </Stack>
            <Stack sx={{ height: '340px', width: '100%', border: '0px solid red', marginTop: '40px', gap: '16px', }} direction={"row"}>
              <Box sx={{ width: '25%', position: 'relative' }}> <img src={dummyProfileInflyxScore} alt="dummyProfileInflyxScore" style={{ width: '100%', height: '100%' }} /> <CommingSoonUi breakLine={true} /></Box>
              <Box sx={{ width: '75%', position: 'relative' }}> <img src={dummyProfileEngagementScore} alt="dummyProfileEngagementScore" style={{ width: '100%', height: '100%' }} /> <CommingSoonUi breakLine={false} /></Box>
            </Stack>
          </Box>
          <Box id='engagement' paddingTop={'60px'}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <img src={engagementIcon} style={{ width: '24px', height: '24px' }} alt={engagementIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Engagement & Views</Typography>
            </Stack>
            <Stack direction={'row'} gap={2} marginTop={'40px'}>
              <Box sx={{ width: '50%', borderRadius: '8px', padding: '2px', background: mainGradient }}>
                <Box sx={{ height: '100%', width: '100%', borderRadius: '6px', padding: '20px', background: 'white' }}>
                  <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1} marginBottom={'30px'}>
                    <img src={profileReelIcon} alt="profileReelIcon" style={{ height: '20px', width: '20px' }} /><Typography fontSize={16} fontWeight={500} color={"black"}>{data?.platform === "youtube" ? "Video" : "Posts"}</Typography>
                  </Stack>
                  <Stack direction={"column"} gap={4} justifyContent={"flex-start"}>
                    <Stack direction={"row"} gap={2} width={"100%"}>
                      <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.posts?.avg_comments) || "N/A"} text="Avg. Comments" />
                      <EngagementInfoCard image={likeIcon} value={getFixedValue(data?.Engagement?.posts?.avg_likes) || "N/A"} text="Avg. Likes" />
                    </Stack>
                    {data?.platformType !== YOUTUBE_TYPE && <><Stack direction={"row"} gap={2} width={"100%"}>
                      <EngagementInfoCard image={engagementIcon} value={data?.Engagement?.posts?.engagement_rate > 0 ? data?.Engagement?.posts?.engagement_rate?.toFixed(2) + "%" : "N/A"} text="Engagement Rate" />
                      <EngagementInfoCard image={eyeIcon} value={data?.Engagement?.posts?.estimated_reach > 0 ? getFixedValue(data?.Engagement?.posts?.estimated_reach) : "N/A"} text="Estimated Reach" />
                    </Stack>
                    </>}
                    {data?.platformType === YOUTUBE_TYPE && <EngagementInfoCard image={eyeIcon} value={getFixedValue(data?.Engagement?.posts?.avg_views) || "N/A"} text="Avg. Views" />}
                  </Stack>
                </Box>
              </Box>
              {data?.platformType != YOUTUBE_TYPE && <Box sx={{ width: '50%', borderRadius: '8px', padding: '2px', background: mainGradient }}>
                <Box sx={{ height: '100%', width: '100%', borderRadius: '6px', padding: '20px', background: 'white' }}>
                  <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1} marginBottom={'30px'}>
                    <img src={profileReelIcon} alt="profileReelIcon" style={{ height: '20px', width: '20px' }} /><Typography fontSize={16} fontWeight={500} color={"black"}>{data?.platform === "youtube" ? "Shorts" : "Reels"}</Typography>
                  </Stack>
                  <Stack direction={"column"} gap={2} justifyContent={"space-between"}>
                    <Stack direction={"row"} gap={2} width={"100%"}>
                      <EngagementInfoCard image={eyeIcon} value={getFixedValue(data?.Engagement?.reels?.avg_views) || "N/A"} text="Avg. Views" />
                      <EngagementInfoCard image={likeIcon} value={getFixedValue(data?.Engagement?.reels?.avg_likes) || "N/A"} text="Avg. Likes" />
                      <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.reels?.avg_comments) || "N/A"} text="Avg. Comments" />
                    </Stack>
                    <Stack direction={"row"} gap={2} width={"100%"}>
                      <EngagementInfoCard image={engagementIcon} value={data?.Engagement?.reels?.engagement_rate > 0 ? data?.Engagement?.reels?.engagement_rate?.toFixed(2) + "%" : "N/A"} text="Engagement Rate" />
                      <EngagementInfoCard image={eyeIcon} value={data?.Engagement?.reels?.view_rate ? data?.Engagement?.reels?.view_rate?.toFixed(2) + "%" : "N/A"} text="View Rate" />
                    </Stack>
                  </Stack>
                </Box>
              </Box>}
            </Stack>
            <Stack sx={{ height: '340px', width: '100%', border: '0px solid red', marginTop: '40px', gap: '16px' }} direction={"row"}>
              <Stack
                sx={{
                  width: "75%",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
                direction="row">
                <Stack justifyContent={"space-between"} sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}> <img src={trendingUpIcon} alt="trendingUpIcon" style={{ height: '30px', width: '30px', display: 'none' }} /> <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.overview?.likesToCommentsRatio?.toFixed(2) || "No Data Found"}</Typography><Typography fontSize={12} fontWeight={400} color={"#726C6C"}>per 30 days</Typography></Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C' }}>Likes - Comments Ratio</Typography>
                </Stack>
                <Stack justifyContent={"space-between"} sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}> <img src={trendingUpIcon} alt="trendingUpIcon" style={{ height: '30px', width: '30px', display: 'none' }} /> <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.platformType !== YOUTUBE_TYPE ? data?.overview?.reelViewsToFollowersRatio?.toFixed(2) || "No Data Found" : data?.overview?.recurringViewership?.toFixed(2)}</Typography></Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C', textTransform: 'capitalize' }}>{data?.platformType !== YOUTUBE_TYPE ? "Reel views to followers ratio" : "RECURRING VIEWERSHIP"}</Typography>
                </Stack>
                <Stack justifyContent={"space-between"} sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}><Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.platformType !== YOUTUBE_TYPE ? data?.overview?.postFrequency?.toFixed(2) || "No Data Found" : data?.overview?.abilitytotriggerConversation?.toFixed(2) || "No Data Found"}</Typography></Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C', textTransform: 'capitalize' }}>{data?.platformType !== YOUTUBE_TYPE ? "Post frequency" : "ABILITY TO TRIGGER CONVERSATIONS IN COMMENTS"}</Typography>
                </Stack>
                {data?.platformType === YOUTUBE_TYPE && <Stack justifyContent={"space-between"} sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px', }}>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}><Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.overview?.likabilityOfTheVideo?.toFixed(2) || "No Data Found"}</Typography></Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C' }}>LIKABILITY OF THE VIDEO</Typography>
                </Stack>}
              </Stack>
              <Box sx={{ width: '25%', position: 'relative' }}>
                <img src={dummyProfileOverallScore} alt="dummyProfileOverallScore" style={{ width: '100%', height: '100%' }} />
                <CommingSoonUi breakLine={true} />
              </Box>
            </Stack>
            {data?.platformType !== YOUTUBE_TYPE && <><Stack direction={"row"} gap={1} alignItems={"center"} paddingTop={"60px"} border="0px solid red">
              <img src={engagementIcon} style={{ width: '24px', height: '24px' }} alt={engagementIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>PAID PARTNERSHIPS - ENGAGEMENTS & VIEWS</Typography>
            </Stack><Stack direction={'row'} gap={2} marginTop={'40px'} border="0px solid red">
                <Box sx={{ width: '50%', borderRadius: '8px', padding: '2px', background: mainGradient }}>
                  <Box sx={{ height: '100%', width: '100%', borderRadius: '6px', padding: '20px', background: 'white' }}>
                    <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1} marginBottom={'30px'}>
                      <img src={profileReelIcon} alt="profileReelIcon" style={{ height: '20px', width: '20px' }} /><Typography fontSize={16} fontWeight={500} color={"black"}>{data?.platform === "youtube" ? "Video" : "Posts"}</Typography>
                    </Stack>
                    <Stack direction={"row"} justifyContent={"center"} gap={4} flexWrap={"wrap"}>
                      <Stack direction={"row"} width={"100%"} gap={2}>
                        <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.posts?.total) || "N/A"} text="Total Posts" />
                        <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.posts?.avg_comments) || "N/A"} text="Avg. Comments" />
                      </Stack>
                      <Stack direction={"row"} width={"100%"} gap={2}>
                        <EngagementInfoCard image={engagementIcon} value={data?.Engagement?.paid_partnerships?.posts?.engagement_rate?.toFixed(2) > 0 ? data?.Engagement?.paid_partnerships?.posts?.engagement_rate?.toFixed(2) + "%" : "N/A"} text="Engagement Rate" />
                        <EngagementInfoCard image={likeIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.posts?.avg_likes) || "N/A"} text="Avg. Likes" />
                      </Stack>
                    </Stack>
                  </Box>
                </Box>
                <Box sx={{ width: '50%', borderRadius: '8px', padding: '2px', background: mainGradient }}>
                  <Box sx={{ height: '100%', width: '100%', borderRadius: '6px', padding: '20px', background: 'white' }}>
                    <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1} marginBottom={'30px'}>
                      <img src={profileReelIcon} alt="profileReelIcon" style={{ height: '20px', width: '20px' }} /><Typography fontSize={16} fontWeight={500} color={"black"}>{data?.platform === "youtube" ? "Shorts" : "Reels"}</Typography>
                    </Stack>
                    <Stack direction={"row"} justifyContent={"space-between"} flexWrap={"wrap"} gap={4}>
                      <Stack direction={"row"} width={"100%"} gap={2}>
                        <EngagementInfoCard image={eyeIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.reels?.total) || "N/A"} text="Total Reels" />
                        <EngagementInfoCard image={eyeIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.reels?.avg_views) || "N/A"} text="Avg. Views" />
                        <EngagementInfoCard image={likeIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.reels?.avg_likes) || "N/A"} text="Avg. Likes" />
                      </Stack>
                      <Stack direction={"row"} width={"100%"} gap={2}>
                        <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.reels?.avg_comments) || "N/A"} text="Avg. Comments" />
                        <EngagementInfoCard image={engagementIcon} value={data?.Engagement?.paid_partnerships?.reels?.engagement_rate > 0 ? data?.Engagement?.paid_partnerships?.reels?.engagement_rate?.toFixed(2) + "%" : "N/A"} text="Engagement Rate" />
                        <EngagementInfoCard image={eyeIcon} value={data?.Engagement?.paid_partnerships?.reels?.view_rate != undefined && data?.Engagement?.paid_partnerships?.reels?.view_rate > 0 ? data?.Engagement?.paid_partnerships?.reels?.view_rate.toFixed(2) + "%" : "N/A"} text="View Rate" />
                      </Stack>
                    </Stack>
                  </Box>
                </Box>
              </Stack></>}
          </Box>
          <Box id="audience" paddingTop="60px">
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <img src={usersIcon} style={{ width: '24px', height: '24px' }} alt="usersIcon" />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Audience</Typography>
            </Stack>
            <Stack direction={"row"} justifyContent={"flex-start"} gap={2} alignItems={"center"} paddingTop="40px">
              <LocationCard image={mapPinIcon} text={"Top City"} value={data?.Audience?.cities?.length > 0 ? getMaximumKey(data?.Audience?.cities) : "N/A"} />
              {data?.platformType !== YOUTUBE_TYPE && <LocationCard image={navigationIcon} text={"Top State"} value={data?.Audience?.state?.length > 0 ? getMaximumKey(data?.Audience?.state) : "N/A"} />}
              <LocationCard image={globeIcon} text={"Top Country"} value={data?.Audience?.country?.length > 0 ? COUNTRY_JSON[getMaximumKey(data?.Audience?.country)] || "N/A" : "N/A"} />
              <LocationCard image={usersIcon} text={"Top Gender"} value={data?.Audience?.gender?.length > 0 ? getGender(getMaximumKey(data?.Audience?.gender?.filter((v, i) => v['U'] === undefined))) : "N/A"} />
              <LocationCard image={cakeIcon} text={"Top Age Group"} value={data?.Audience?.age_group?.length > 0 ? formatAgeString(getMaximumKey(data?.Audience?.age_group)) + " Years" : "N/A"} />
              <LocationCard image={certificateIcon} text={"Audience Quality"} value={"N/A"} />
            </Stack>
            {(data?.Audience?.gender?.length>0 || data?.Audience?.age_group?.length>0) && <Stack sx={{ height: '340px', width: '100%', border: '0px solid red', marginTop: '40px', gap: '16px' }} direction={"row"}>
             {data?.Audience?.age_group.length>0 && <Stack
                sx={{
                  width: "65%",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
                direction="row">
                <Box sx={{ height: '100%', width: '100%', padding: '20px', border: '1px solid #EEE', borderRadius: '12px' }}>
                  <Typography fontSize={16} fontWeight={500} color={"black"}>Audience Age Group</Typography>
                  <Box height={"100%"} width={"100%"} paddingY={"20px"}>
                    <Bar datasetIdKey='id'
                      data={dataForAgeGroupGraph} options={{
                        responsive: true,
                        maintainAspectRatio: false, // allows filling parent container
                        plugins: {
                          legend: { display: false },
                          title: {
                            display: true,
                            text: "Audience Age Group",
                            padding: { top: 8, bottom: 16 },
                          },
                          datalabels: {
                            anchor: "end",
                            align: "end",
                            formatter: (value) => `${value}%`,
                            font: { weight: "600", size: 12 },
                            color: "#444",
                          },
                          tooltip: {
                            callbacks: {
                              label: (context) => `${context.raw}%`,
                            },
                          },
                        },
                        scales: {
                          x: {
                            grid: {
                              display: false, // no vertical grid lines
                              drawBorder: false, // hide x axis border
                            },
                            ticks: { display: true },
                          },
                          y: {
                            beginAtZero: true,
                            max: 100,
                            ticks: {
                              stepSize: 20,
                              callback: (v) => `${v}%`,
                            },
                            grid: {
                              display: true,        // show horizontal lines
                              drawBorder: false,    // hide axis border
                              drawTicks: false,     // hide small tick marks
                              color: "#e6e6e6",     // light gray
                              borderDash: [6, 6],   // <-- dashed pattern (array)
                              borderDashOffset: 0,  // number, not array
                              lineWidth: 1,
                            },
                          },
                        },
                      }}
                    />
                  </Box>
                </Box>
              </Stack>}
          {data?.Audience?.gender.length>0 &&    <Box sx={{ width: '35%', position: 'relative', padding: '20px', border: '1px solid #EEE', borderRadius: '12px', height: '100%' }}>
                <Typography fontSize={16} fontWeight={500} color={"black"}>Audience Age Group</Typography>
                <Stack direction={"row"} width={"100%"} height={"100%"}>
                  <Stack direction={"column"} justifyContent={"center"} alignItems={"center"} gap={3} sx={{ padding: '0', margin: 0, width: '50%', height: '100%', }}>
                    <Box sx={{ position: "relative", width: 176, height: 176 }}>
                      <svg viewBox="0 0 36 36" style={{ width: "100%", height: "100%" }}>
                        <path
                          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
                          style={{
                            fill: "none",
                            stroke: "#D9D9D9",
                            strokeWidth: 3.4,
                          }}
                        />
                        <path
                          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
                          style={{
                            fill: "none",
                            stroke: "#45B3AC",
                            strokeWidth: 3.4,
                            strokeLinecap: "round",
                            transition: "stroke-dasharray 1s ease-out",
                            strokeDasharray: `${GENDER_AUDIANCE_GRAPH_DATA?.[0]?.percentage || 0}, 100`,
                          }}
                        />
                      </svg>
                      <Box
                        sx={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                        }}
                      >
                        <img src={maleIcon} alt="icon" style={{ width: "31px", height: "64px" }} />
                        <Typography fontSize={20} fontWeight={600} color={'black'}>
                          {GENDER_AUDIANCE_GRAPH_DATA?.[0]?.percentage || 0}%
                        </Typography>
                      </Box>
                    </Box>
                    <Stack direction={'row'} gap={1} justifyContent={"center"} alignItems={"center"}><Box sx={{ height: '10px', width: '10px', background: '#45B3AC', borderRadius: '50%' }}></Box><Typography fontSize={20} fontWeight={500} color={'black'}>{GENDER_AUDIANCE_GRAPH_DATA?.[0]?.percentage || 0}% <span style={{ fontSize: '14px', fontWeight: 400 }}>Male</span></Typography></Stack> </Stack>
                  <Stack direction={"column"} justifyContent={"center"} alignItems={"center"} gap={3} sx={{ padding: '0', margin: 0, width: '50%', height: '100%', }}>
                    <Box sx={{ position: "relative", width: 176, height: 176 }}>
                      <svg viewBox="0 0 36 36" style={{ width: "100%", height: "100%" }}>
                        <path
                          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
                          style={{
                            fill: "none",
                            stroke: "#D9D9D9",
                            strokeWidth: 3.4,
                          }}
                        />
                        <path
                          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
                          style={{
                            fill: "none",
                            stroke: "#F72585",
                            strokeWidth: 3.4,
                            strokeLinecap: "round",
                            transition: "stroke-dasharray 1s ease-out",
                            strokeDasharray: `${GENDER_AUDIANCE_GRAPH_DATA?.[1]?.percentage || 0}, 100`,
                          }}
                        />
                      </svg>
                      <Box
                        sx={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                        }}
                      >
                        <img src={femaleIcon} alt="icon" style={{ width: "31px", height: "64px" }} />
                        <Typography fontSize={20} fontWeight={600} color={'black'}>
                          {GENDER_AUDIANCE_GRAPH_DATA?.[1]?.percentage || 0}%
                        </Typography>
                      </Box>
                    </Box>
                    <Stack direction={'row'} gap={1} justifyContent={"center"} alignItems={"center"}><Box sx={{ height: '10px', width: '10px', background: '#F72585', borderRadius: '50%' }}></Box><Typography fontSize={20} fontWeight={500} color={'black'}>{GENDER_AUDIANCE_GRAPH_DATA?.[1]?.percentage || 0}% <span style={{ fontSize: '14px', fontWeight: 400 }}>Female</span></Typography></Stack> </Stack>
                </Stack>
              </Box>}
            </Stack>}
            {(data?.Audience?.state?.length > 0 || data?.Audience?.country?.length > 0 || data?.Audience?.cities?.length > 0)&&<Box sx={{ height: '340px', width: '100%', padding: '20px', border: '1px solid #EEE', borderRadius: '12px', overflow: 'hidden',marginTop: '40px' }}>
              <Stack direction={"row"} justifyContent={"space-between"} background={"white"} zIndex={2} paddingBottom={"15px"}  >
                <Typography fontSize={16} fontWeight={500} color={"black"}>AUDIENCE GEOGRAPHY</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', border: '1px solid #EEE', padding: '4px', borderRadius: '4px' }}>
                  <Stack direction="row" spacing={1} border={'0px solid #F0F0F0'}>
                    {console.log(audienceTab, 'tabtab')}
                    <Button onClick={() => setAudienceTab("city")} sx={{
                      color: audienceTab === "city" ? "white" : 'black', background: audienceTab === "city" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                    }} ><Typography fontSize={12} fontWeight={500} color={audienceTab === "city" ? "white" : 'black'} background={audienceTab === "city" ? "var(--color-blue)" : 'white'}>City</Typography></Button>
                    <Button onClick={() => setAudienceTab("state")} sx={{
                      color: audienceTab === "state" ? "white" : 'black', background: audienceTab === "state" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                    }} ><Typography fontSize={12} fontWeight={500} color={audienceTab === "state" ? "white" : 'black'} background={audienceTab === "state" ? "var(--color-blue)" : 'white'}>State</Typography></Button>
                    <Button onClick={() => setAudienceTab("country")} sx={{
                      color: audienceTab === "country" ? "white" : 'black', background: audienceTab === "country" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                    }}><Typography fontSize={12} fontWeight={500} color={audienceTab === "country" ? "white" : 'black'} background={audienceTab === "country" ? "var(--color-blue)" : 'white'}>Country</Typography></Button>
                  </Stack>
                </Box>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"} gap={"20px"} flexWrap={"wrap"} zIndex={0} position={"relative"} height={"240px"} sx={{ overflowY: 'scroll', overflowX: 'hidden', border: '0px solid red', ...hideScrollbarCss }} >
                {/* <Box sx={{width:'50%',border:'1px solid red'}}> */}
                {audienceTab === 'state' && (data?.Audience?.state?.length > 0 ? getTop10Records(data?.Audience?.state)?.map((obj, i) => {
                  const key = Object.keys(obj)[0];
                  const value = obj[key];
                  const percentage = ((value / sumOfAll(getTop10Records(data?.Audience?.state))) * 100);
                  return <Box sx={{ width: 'calc(50% - 10px)', border: '0px solid red' }} key={i}> <LinearProgressWithLabel value={percentage} country={key} /></Box>
                }) : <span>No Data Found</span>)}
                {audienceTab === 'city' && (data?.Audience?.cities?.length > 0 ? getTop10Records(data?.Audience?.cities)?.map((obj, i) => {
                  const key = Object.keys(obj)[0];
                  const value = obj[key];
                  return <Box sx={{ width: 'calc(50% - 10px)', border: '0px solid red' }} key={i}><LinearProgressWithLabel value={((value / sumOfAll(getTop10Records(data?.Audience?.cities))) * 100)} country={key} /></Box>
                }) : <span>No Data Found</span>)}
                {audienceTab === 'country' && (data?.Audience?.country?.length > 0 ? getTop10Records(data?.Audience?.country)?.map((obj, i) => {
                  const key = Object.keys(obj)[0];
                  const value = obj[key];
                  const val = COUNTRY_JSON[key.toUpperCase()] || "-";
                  const v = (value / sumOfAll(getTop10Records(data?.Audience?.country))) * 100;
                  return <Box sx={{ width: 'calc(50% - 10px)', border: '0px solid red' }} key={i}><LinearProgressWithLabel value={v} country={val} /></Box>
                }) : <span>No Data Found</span>)}
              </Stack>
            </Box>}
          </Box>
          <Box id="content" paddingTop={"60px"}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <img src={imageIcon} style={{ width: '24px', height: '24px' }} alt={engagementIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Content</Typography>
            </Stack>
            <Grid container paddingTop={"40px"}>
              {
                (Array.isArray(data?.content?.hashtags) ? [...data?.content?.hashtags].sort((a, b) => b.value - a.value).slice(0, showAllHastags ? 26 : 11) : []).map((item, index) => (
                  <Grid key={item?.text} item xs={4} sx={{ height: '50px', padding: '0 30px 0 0', border: '0px solid red' }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #F0F0F0', paddingY: '20px', height: '100%' }}><Stack direction="row" gap={1} alignItems='center'>
                      <Typography fontSize="16px" fontWeight={400}>{index + 1}.</Typography>
                      <Typography fontSize="16px" fontWeight={400}>{item?.text}</Typography>
                    </Stack> <Typography color="#9F9C9C" fontSize="14px" fontWeight={400}>{item?.value} Post</Typography></Stack>
                  </Grid>
                ))
              }
              {data?.content?.hashtags?.length > 11 && <Grid item xs={4} sx={{ height: '50px', padding: 0 }}>
                <Stack direction="row" justifyContent="flex-end" alignItems="center" sx={{ paddingY: '20px', height: '100%', borderBottom: '1px solid #F0F0F0', }}>
                  <Button onClick={() => { setShowAllHastags(prev => !prev); console.log('dhbhd') }} disableRipple sx={{
                    "&:hover": {
                      background: 'none'
                    }
                  }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 400, color: 'var(--color-blue)' }}>{showAllHastags ? "See Less" : "See All"}
                    </Typography>
                  </Button>
                </Stack>
              </Grid>}
            </Grid>
            <Posts details={data} flag={true} />
          </Box>
          <Box id="growth" paddingTop={"60px"}>
            <Stack direction={"row"} gap={1} alignItems={"center"} marginBottom="40px">
              <img src={growthIcon} style={{ width: '24px', height: '24px' }} alt={engagementIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Growth</Typography>
            </Stack>
            <Stack
              sx={{
                width: "100%",
                flexWrap: "wrap",
                gap: "16px",
              }}
              direction="row">
              <Box sx={{ height: '100%', padding: '20px', border: '1px solid #EEE', borderRadius: '12px', width: "calc(50% - 8px)", }}>
                <Typography fontSize={16} fontWeight={500} color={"black"} paddingBottom={'15px'} display="flex" alignItems="center" gap={1}>30D FOLLOWERS GROWTH RATE <Tooltip arrow title="30D followers growth rate is a
measure of how many new followers
an influencer has gained or lost over a
period of 30 days, expressed as a
percentage." componentsProps={TOOLTIP_STYLES}><img src={infoIcon} style={{ width: '20px', height: '20px' }} alt="" /></Tooltip></Typography>
                <Typography fontSize={16} fontWeight={700} color={"black"}>{parseFloat(data?.Audience?.growth)?.toFixed(2) + "%" || "N/A"}</Typography>
              </Box>
              <Box sx={{ height: '100%', padding: '20px', border: '1px solid #EEE', borderRadius: '12px', width: "calc(50% - 8px)", }}>
                <Typography fontSize={16} fontWeight={500} color={"black"} paddingBottom={'15px'} display="flex" alignItems="center" gap={1}>30D FOLLOWERS GAIN <Tooltip arrow title="30D followers gain shows the total
number of followers this influencer
gained or lost over a period of 30
days." componentsProps={TOOLTIP_STYLES}><img src={infoIcon} style={{ width: '20px', height: '20px' }} alt="" /></Tooltip></Typography>
                <Typography fontSize={16} fontWeight={700} color={"black"}>{getFixedValue(data?.Audience?.monthGain) || "N/A"}</Typography>
              </Box>
            </Stack>
          </Box>
          <Box id="brands" paddingTop={"60px"}>
            <Brands brands={data?.Brands} handleId={data?.handleRecordId} userId={data?.userId} />
          </Box>
        </Box>
      </Stack>
    </>
  )
}
export default SocialProfileSummary